"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var react_1 = require("@chakra-ui/react");
var styles_1 = __importDefault(require("./styles"));
var breakpoints_1 = __importDefault(require("./foundations/breakpoints"));
var colors_1 = __importDefault(require("./foundations/colors"));
var typography_1 = __importDefault(require("./foundations/typography"));
var radii_1 = __importDefault(require("./foundations/radii"));
var shadow_1 = __importDefault(require("./foundations/shadow"));
var space_1 = __importDefault(require("./foundations/space"));
var Alert_1 = __importDefault(require("./components/Alert"));
var Avatar_1 = __importDefault(require("./components/Avatar"));
var Badge_1 = __importDefault(require("./components/Badge"));
var Button_1 = __importDefault(require("./components/Button"));
var Icon_1 = __importDefault(require("./components/Icon"));
var Input_1 = __importDefault(require("./components/Input"));
var Link_1 = __importDefault(require("./components/Link"));
var Modal_1 = __importDefault(require("./components/Modal"));
var Progress_1 = __importDefault(require("./components/Progress"));
var Radio_1 = __importDefault(require("./components/Radio"));
var Select_1 = __importDefault(require("./components/Select"));
var Switch_1 = __importDefault(require("./components/Switch"));
var Tabs_1 = __importDefault(require("./components/Tabs"));
var Text_1 = __importDefault(require("./components/Text"));
var Tooltip_1 = __importDefault(require("./components/Tooltip"));
exports.theme = (0, react_1.extendTheme)({
    styles: styles_1.default,
    breakpoints: breakpoints_1.default,
    colors: colors_1.default,
    fonts: typography_1.default,
    fontSizes: typography_1.default.fontSize,
    radii: radii_1.default,
    shadows: shadow_1.default,
    space: space_1.default,
    components: {
        Alert: Alert_1.default,
        Avatar: Avatar_1.default,
        Badge: Badge_1.default,
        Button: Button_1.default,
        Icon: Icon_1.default,
        Input: Input_1.default,
        Link: Link_1.default,
        Modal: Modal_1.default,
        Progress: Progress_1.default,
        Radio: Radio_1.default,
        Select: Select_1.default,
        Switch: Switch_1.default,
        Tabs: Tabs_1.default,
        Text: Text_1.default,
        Tooltip: Tooltip_1.default,
    },
});
